// studyTimer.js

let studyStart = null;

export function initStudyTracking(sendTimeCallback) {
  function startTracking() {
    if (!studyStart) {
      studyStart = Date.now();
    }
  }

  function stopTracking() {
    if (studyStart) {
      const seconds = Math.floor((Date.now() - studyStart) / 1000);
      sendTimeCallback(seconds);
      studyStart = null;
    }
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) stopTracking();
    else startTracking();
  });

  window.addEventListener("blur", stopTracking);
  window.addEventListener("focus", startTracking);

  if (document.visibilityState === "visible") startTracking();

  // Optional: when user leaves the page
  window.addEventListener("beforeunload", stopTracking);
}
